import {
    Checkbox,
    CheckboxProps,
    FormControlLabel,
    Typography,
} from "@mui/material";

type CustomCheckBoxProps = {
    label: string;
    customlabelsx?: object;
    errortext?: string;
};

export default function CustomCheckBox(
    props: CheckboxProps & CustomCheckBoxProps
) {
    const { label, customlabelsx, errortext, ...checkBoxProps } = props;
    return (
        <>
            <FormControlLabel
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "0.5rem",
                    "&.MuiFormControlLabel-root": {
                        margin: 0,
                    },
                }}
                control={
                    <Checkbox
                        sx={{
                            display: "flex",
                            width: "1rem",
                            height: "1rem",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "0.25rem",
                            gap: "0.5rem",
                            color: "#0082DE",
                            "&.Mui-checked": {
                                color: "#0082DE",
                            },
                            border: "2px solid  #0082DE",
                            padding: 0,
                        }}
                        {...checkBoxProps}
                    />
                }
                label={
                    <Typography
                        sx={
                            customlabelsx ?? {
                                color: "#023",
                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "normal",
                            }
                        }
                    >
                        {label}
                    </Typography>
                }
            />
            {errortext ? (
                <Typography
                    sx={{
                        fontSize: {
                            xs: "15px",
                            md: "17px",
                        },
                        fontWeight: "600",
                        fontFamily: "Gotham Book",
                        marginBottom: "10px",
                    }}
                    color="#E51846"
                >
                    {errortext ?? ""}
                </Typography>
            ) : (
                <></>
            )}
        </>
    );
}
